export enum ImageDetailsPageTabs {
  Overview = 'overview',
}
